import { useEffect } from "react";

export default function BaseModal({
  open,
  onClose,
  title,
  meta,
  children,
  modalId,
  size = "md",
  footer,
  className = "",
}) {
  useEffect(() => {
    if (!open) {
      return undefined;
    }

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [onClose, open]);

  if (!open) {
    return null;
  }

  return (
    <div
      className="modal-backdrop open"
      onClick={(event) => {
        if (event.target === event.currentTarget) {
          onClose();
        }
      }}
    >
      <div
        className={`modal modal-${size} ${className}`.trim()}
        id={modalId}
        role="dialog"
        aria-modal="true"
        aria-labelledby={title ? `${modalId || "base-modal"}-title` : undefined}
      >
        <div className="modal-header">
          <div>
            <div className="modal-title" id={`${modalId || "base-modal"}-title`}>
              {title}
            </div>
            {meta ? <div className="modal-meta">{meta}</div> : null}
          </div>
          <button
            className="modal-close"
            type="button"
            aria-label="Close modal"
            onClick={onClose}
          >
            x
          </button>
        </div>
        <div className="modal-body">{children}</div>
        {footer ? <div className="modal-footer">{footer}</div> : null}
        {/* TODO(ui): focus trap and scroll lock need modal behavior changes; skipped per visual-only scope. */}
      </div>
    </div>
  );
}
